export const vueI18n = {"fallbackLocale":"id"}
export const vueI18nLoader = false
export const locales = [{"code":"en","iso":"en-ID","file":"english/index.js","name":"English"},{"code":"id","iso":"id-ID","file":"indonesia/index.js","name":"Indonesia"},{"code":"ms","iso":"ms-MY","file":"malaysia/index.js","name":"malaysia"},{"code":"vi","iso":"vi-VN","file":"vietnam/index.js","name":"vietnam"},{"code":"th","iso":"th-TH","file":"thailand/index.js","name":"thailand"}]
export const defaultLocale = 'id'
export const routesNameSeparator = '___'
export const defaultLocaleRouteNameSuffix = 'default'
export const strategy = 'prefix_except_default'
export const lazy = true
export const langDir = 'lang/'
export const rootRedirect = null
export const detectBrowserLanguage = false
export const differentDomains = false
export const seo = true
export const baseUrl = ''
export const vuex = {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true}
export const parsePages = true
export const pages = {}
export const beforeLanguageSwitch = () => null
export const onLanguageSwitched = () => null
export const IS_UNIVERSAL_MODE = false
export const MODULE_NAME = 'nuxt-i18n'
export const LOCALE_CODE_KEY = 'code'
export const LOCALE_ISO_KEY = 'iso'
export const LOCALE_DOMAIN_KEY = 'domain'
export const LOCALE_FILE_KEY = 'file'
export const STRATEGIES = {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"}
export const COMPONENT_OPTIONS_KEY = 'nuxtI18n'
export const localeCodes = ["en","id","ms","vi","th"]
export const trailingSlash = undefined
